import axios from "axios";
import { API_BASE_URL } from "../config/api";

export const createExercise = async (exerciseData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/exercises`, exerciseData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating exercise:", error.response?.data || error.message);
    throw error;
  }
};

export const getExercises = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/exercises`, {
      headers: {
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching exercises:", error);
    throw error;
  }
};

export const getUniqueBackgrounds = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/exercises/unique/bg`, {
      headers: {
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching unique backgrounds:", error.response?.data || error.message);
    throw new Error(
      "Failed to fetch background images: " +
        (error.response?.data?.message || error.message)
    );
  }
};

export const getExercise = async (id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/exercises/${id}`, {
      headers: {
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching exercise:", error);
    throw error;
  }
};

export const updateExercise = async (id, formData) => {
  try {
    // Log FormData contents for debugging
    const formDataObj = {};
    for (let [key, value] of formData.entries()) {
      formDataObj[key] = value instanceof File ? `File: ${value.name}` : value;
    }
    console.log(`Sending update request for ID ${id}:`, formDataObj);

    const response = await axios.post(
      `${API_BASE_URL}/exercises/${id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating exercise:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });
    throw error;
  }
};

export const deleteExercise = async (id) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/exercises/${id}`, {
      headers: {
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting exercise:", error);
    throw error;
  }
};